export default __webpack_public_path__ + "static/media/brown-4.18aa808d.png";